import { WorkflowStepsBaseService } from "app/core/workflow/workflow-steps/workflow-steps-base.service";
import { TaxDocumentsComponentPath } from "app/core/workflow/page-path/statement-page-path/tax-documents-component.path";

export class WorkflowTaxDocumentsService extends WorkflowStepsBaseService {
  public get isDone(): boolean {
    return !!this.statement && !this.statement.hasOpenDocumentRequest;
  }

  public get isRequired(): boolean {
    return (
      !!this.statement &&
      (this.statement.isPaid || this.statement.isSent()) &&
      !this.statement.isForClientApproval &&
      !this.statement.isApproved &&
      !this.statement.isReportedErrors &&
      !this.statement.batchId &&
      !this.isBusiness &&
      !this.isTaxAdviser &&
      this.statement.isPremiumPackage &&
      !!this.statement.vollmachtSigned &&
      !!this.statement.hasOpenDocumentRequest
    );
  }

  public get checkCanGo(): boolean {
    return !!this.statement && this.isRequired;
  }

  public get skipWorkflowMechanisms(): boolean {
    return true;
  }

  public get urlRegex(): RegExp {
    return TaxDocumentsComponentPath.regex();
  }

  public get url(): string {
    return TaxDocumentsComponentPath.url(this.getStatementId);
  }
}
